const Breakpoints = {
  mobile: 0,
  tablet: 768,
  desktop: 1024,
  desktopLarge: 1200,
  desktopWide: 1440,
};

/* @component */
export default Breakpoints;
